import { render, staticRenderFns } from "./UnreadComponent.vue?vue&type=template&id=2270715d&scoped=true"
import script from "./UnreadComponent.vue?vue&type=script&lang=js"
export * from "./UnreadComponent.vue?vue&type=script&lang=js"
import style0 from "./UnreadComponent.vue?vue&type=style&index=0&id=2270715d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270715d",
  null
  
)

export default component.exports